import React, { useState, useEffect } from "react";
import classNames from "classnames";
import Image from "react-bootstrap/Image";
import DetailsPanel from "./DetailsPanel";
import { useAlert } from "../../contexts/AlertContext";
import Button from "react-bootstrap/Button";
import { useAtom } from "jotai";
import { authAtom } from "../../states/auth";
import styles from "./DetailsPanel.module.scss";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { rescheduleCallRequest, endConversationRequest } from "../../services/supportService";
import { checkExpiredConversation } from "../../services/chatServices";
import { vonageAccessToken } from "../../services/vonageServices";
import { createCall } from "../../services/callServices";
import ImagePreviewLightbox from "../ImagePreviewLightbox";
import { getCompanyStatus } from "../../pages/CompanyStatus";
import moment from "moment/moment";

const formatDateForInputLocal = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr); // UTC → local
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const formatTimeForInputLocal = (dateStr) => {
  if (!dateStr) return "";
  const d = new Date(dateStr); // UTC → local
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

const formatDateTimeToString = (dateObjTmp) => {
  const dateObj = new Date(dateObjTmp);
  if (dateObj) {
    const formattedDate = dateObj.toLocaleDateString('en-GB'); // Gives "dd/mm/yyyy"
    const formattedTime = dateObj.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true, // ensures AM/PM format
    });
    const formattedDateWithDashes = formattedDate?.replace(/\//g, '-'); // converts dd/mm/yyyy to dd-mm-yyyy
    return `${formattedDateWithDashes}, ${formattedTime}`;
  }
}

const getHourMinuteDiffString = (date1, date2) => {
  const msDiff = Math.abs(date2 - date1);
  const totalMinutes = Math.floor(msDiff / (1000 * 60));
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  if (hours === 0) {
    return `${minutes}m`;
  } else if (minutes === 0) {
    return `${hours}h`;
  } else {
    return `${hours}h ${minutes}m`;
  }
};

function evaluateSessionTiming(startDateUTC, endDateUTC, isChat) {
  if (isChat === true) {
    return {
      isFutureSession: false,
      isPastSession: false,
      isSessionInWhile: false,
      isCurrentSession: false
    };
  }

  const now = new Date(); // local time
  const startDate = new Date(startDateUTC); // UTC input
  const endDate = new Date(endDateUTC);     // UTC input

  const isFutureSession = startDate > now;
  const isPastSession = endDate < now;

  // const isCurrentSession =  startDate > now < endDate;
  const isCurrentSession = startDate <= now && now < endDate;


  const diffInMillis = startDate - now;
  const isSessionInWhile = diffInMillis > 0 && diffInMillis <= 10 * 60 * 1000; // 10 mins in ms

  return {
    isFutureSession,
    isPastSession,
    isSessionInWhile,
    isCurrentSession
  };
}

const getAddress = (userInfo) => {
  const addressArr = [];
  if (userInfo?.createdBy?.address) {
    addressArr.push(userInfo?.createdBy?.address);
  }
  if (userInfo?.createdBy?.city) {
    addressArr.push(userInfo?.createdBy?.city);
  }
  if (userInfo?.createdBy?.state?.name) {
    addressArr.push(userInfo?.createdBy?.state?.name);
  }
  if (userInfo?.createdBy?.country?.code) {
    addressArr.push(userInfo?.createdBy?.country?.code);
  }
  if (userInfo?.createdBy?.zipCode) {
    addressArr.push(userInfo?.createdBy?.zipCode);
  }
  return addressArr.join(", ");
};

const identifyUser = (data) => {
  let userMeta = { label: "", image: "", role: "" };
  if (data?.createdBy?.roleId == 3) {
    if (data?.createdBy?.createdBy === data.admin.id) {
      userMeta = {
        label: "Expert",
        role: "expert",
        image: "/images/user-circle-check-green.svg",
      };
    } else {
      userMeta = {
        label: "External Expert",
        role: "external_expert",
        image: "/images/user-circle-dashed-red.svg",
      };
    }
  } else if (data?.createdBy?.roleId == 5) {

    userMeta = {
      label: "Contacts",
      role: "client",
      image: "/images/user-circle-gear-blue.svg",
    };

  } else if (data?.createdBy?.roleId == 2) {
    if (data?.createdBy?.createdBy === data?.createdBy?.id) {
      userMeta = {
        label: "User",
        role: "internal_user",
        image: "/images/user-circle-gear-blue.svg",
      };
    } else {
      userMeta = {
        label: "User",
        role: "external_user",
        image: "/images/user-circle-yellow.svg"
      };
    }
  }
  return userMeta;
};



const sessionStatusIdentify = (session) => {

  const chatType = (session?.conversationType?.includes("chat")) ? true : false


  const now = new Date(); // local time
  const startDate = new Date(session?.startTime); // UTC input
  const endDate = new Date(session?.endTime);     // UTC input
  if (session?.conversationStatus == "Assigned") {
    if (endDate > now) {
      return { "type": "confirmed", "text": "Confirmed" }
    } else {
      return { "type": "expired", "text": "Exired" }
    }
  } else if (session?.conversationStatus == "Pending") {
    if (endDate < now) {
      return { "type": "expired", "text": "Expired" }
    } else {
      return { "type": "pending", "text": "Pending" }
    }
  }
}

const CalendarDetailsPanel = ({ onClose, setSupportList, item, loggedInUser, getSupportList }) => {

  const [singleInboxItem, setSingleInboxItem] = useState(null);
  const [showModalCancel, setShowModalCancel] = useState(null);
  const [selfCreatedRequest, setSelfCreatedRequest] = useState(null);
  const { showAlert } = useAlert();
  const navigate = useNavigate();
  const startTime = new Date(item?.startTime);
  const endTime = new Date(item?.endTime);
  const chatType = (item?.conversationType?.includes("chat")) ? true : false
  const [rescheduleModal, setRescheduleModal] = useState(false);
  const [requestDate, setRequestDate] = useState("");
  const [startTimeReschedule, setStartTimeReschedule] = useState("");
  const [endTimeReschedule, setEndTimeReschedule] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [timeOptions, setTimeOptions] = useState([])
  const [auth] = useAtom(authAtom);
  const sessionTimeStatus = evaluateSessionTiming(startTime, endTime, chatType)
  const sessionStatus = sessionStatusIdentify(item);
  const userData = identifyUser(item);
  const anotherMember = item?.conversationMembers?.find((e) => e.user_id != auth?.user?.id);

  useEffect(() => {
    if (!requestDate) return; // skip if no date selected yet

    const generateTimeOptions = () => {
      const times = [];
      const now = new Date(); // current actual time
      const selectedDate = new Date(requestDate);
      const isToday =
        selectedDate.toDateString() === now.toDateString();

      for (let hour = 0; hour < 24; hour++) {
        for (let min = 0; min < 60; min += 15) {
          const totalMinutes = hour * 60 + min;
          // only include future times if date is today
          if (!isToday || totalMinutes >= now.getHours() * 60 + now.getMinutes()) {
            const period = hour < 12 ? "AM" : "PM";
            const displayHour = hour % 12 === 0 ? 12 : hour % 12;
            const displayMin = String(min).padStart(2, "0");
            const displayTime = `${displayHour}:${displayMin} ${period}`;
            const value = `${String(hour).padStart(2, "0")}:${displayMin}`;
            times.push({ value, label: displayTime });
          }
        }
      }
      return times;
    };

    setTimeOptions(generateTimeOptions());
  }, [requestDate]);

  const removeConversationById = (idToRemove) => {
    setSupportList(prev => {
      // Optionally, find the object first if you need to do something with it
      const removedItem = prev.find(item => item.id === idToRemove);

      // Now remove it from the list
      const updatedList = prev.filter(item => item.id !== idToRemove);

      // Optional: console log or handle the removed item
      console.log('Removed:', removedItem);

      return updatedList;
    });
  };

  console.log("sessionTimeStatus", sessionTimeStatus)
  console.log("sessionTimeStatus0", sessionStatus)
  console.log("sessionTimeStatus1", userData)

  const validateReschedule = () => {
    const errors = {};

    // Basic required field checks
    if (!requestDate) errors.requestDate = "Request date is required";
    if (!startTimeReschedule) errors.startTimeReschedule = "Start time is required";
    if (!endTimeReschedule) errors.endTimeReschedule = "End time is required";

    if (requestDate && startTimeReschedule && endTimeReschedule) {
      
      const startMoment = moment(`${requestDate} ${startTimeReschedule}`, "YYYY-MM-DD HH:mm");
      const endMoment = moment(`${requestDate} ${endTimeReschedule}`, "YYYY-MM-DD HH:mm");

      const now = moment();
      const today = moment().startOf('day'); 
      const selectedDate = moment(requestDate, "YYYY-MM-DD").startOf('day'); 

      if (endMoment.isSameOrBefore(startMoment)) {
        errors.endTimeReschedule = "End time must be after start time";
      }
      
      if (selectedDate.isBefore(today)) {
        errors.requestDate = "Date cannot be in the past";
      }

      if (selectedDate.isSame(today)) {
        const nowPlus15Min = moment().add(15, 'minutes');
        if (startMoment.isBefore(nowPlus15Min)) {
          errors.startTimeReschedule = "Start time must be at least 15 minutes from now";
        }
      }

      const durationMinutes = endMoment.diff(startMoment, 'minutes');
      if (durationMinutes < 15) {
        errors.endTimeReschedule = "Minimum duration is 15 minutes";
      }

      if (startMoment.minutes() % 15 !== 0) {
        errors.startTimeReschedule = "Start time must be in 15-minute intervals";
      }

      if (endMoment.minutes() % 15 !== 0) {
        errors.endTimeReschedule = "End time must be in 15-minute intervals";
      }
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const rescheduleCall = async () => {
    if (!validateReschedule()) return;

    const startDateTime = new Date(`${requestDate}T${startTimeReschedule}`).toISOString();
    const endDateTime = new Date(`${requestDate}T${endTimeReschedule}`).toISOString();

    try {
      // Call your API here
      const payload = {
        sessionId: singleInboxItem?.id,
        startTime: startDateTime,
        endTime: endDateTime,
      };

      const chatRequestData = await rescheduleCallRequest(singleInboxItem?.id, payload);
      getSupportList();
      // Example using fetch:
      // await fetch("/api/reschedule-session", {
      //   method: "POST",
      //   headers: { "Content-Type": "application/json" },
      //   body: JSON.stringify(payload),
      // });

      // On success
      showAlert({
        title: "Calendar Notification",
        message: chatRequestData?.message ?? "something went wrong",
        variant: "success",
      });
      onClose();
      setRescheduleModal(false);
      setFormErrors({});
    } catch (error) {
      console.error("Failed to reschedule:", error);
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }
  };

  const chatActionHandle = async (id) => {


    try {
      const chatRequestData = await checkExpiredConversation(id);
      console.log(chatRequestData);
      // removeConversationById(id)
      // onSidebarClose()
      navigate("/chat", { state: { "singleInboxItem": chatRequestData.data } })
      showAlert({
        title: "Calendar Notification",
        message: chatRequestData?.message ?? "something went wrong",
        variant: "success",
      });
    } catch (error) {
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }

  }

  const meetingLinkOpen = (event, callId) => {
    event.preventDefault();
    try {

      const callRequest = {
        "roomName": callId,
        "identifierName": auth?.user?.firstName + auth?.user?.lastName
      };

      const data = vonageAccessToken(callRequest).then((resp) => {
        console.log("response", resp);
        localStorage.setItem("vonage_session_id", resp.sessionId);
        localStorage.setItem("vonage_token", resp.token);
        localStorage.setItem("vonage_cid", singleInboxItem?.id);
        localStorage.setItem("vonage_meetingId", callId);
        localStorage.setItem("token", auth?.token);
        navigate("/connect");


        // setChatMessages(prev => [...prev, newMsg]);
        // setMessage('');
        // setSelectedFile(null);
        // scrollToBottom();

      });


    } catch (error) {
      showAlert({
        title: "Chat Screen Notification",
        message: error?.response?.data?.message ?? "Something went wrong",
        variant: "danger",
      });
    }
  }

  const joinCallButton = async (event) => {
    if (singleInboxItem?.calls && singleInboxItem?.calls[0]?.id) {
      // alert(singleInboxItem?.calls && singleInboxItem?.calls[0]?.id);
      meetingLinkOpen(event, singleInboxItem?.calls[0]?.id);
      // setMeetingId(singleInboxItem?.calls && singleInboxItem?.calls[0]?.id);
    } else {
      const data = {
        "conversationID": singleInboxItem?.id
      }
      try {
        const callRequestData = await createCall(data);
        // alert(callRequestData?.data && callRequestData?.data?.id)
        meetingLinkOpen(event, callRequestData?.data?.id);
        // setMeetingId(callRequestData?.data && callRequestData?.data?.id);
      } catch (error) {
        showAlert({
          title: "Chat Notification",
          message: error?.response?.data?.message ?? "something went wrong",
          variant: "danger",
        });
      }
    }
  }

  const cancelRequest = async (id) => {

    const data = {
      "action": "cancel_support"
    }
    try {
      const callRequestData = await endConversationRequest(id, data);
      removeConversationById(id);
      setShowModalCancel(false);
      onClose();
      showAlert({
        title: "Calendar Notification",
        message: callRequestData?.message ?? "something went wrong",
        variant: "success",
      });
    } catch (error) {
      showAlert({
        title: "Calendar Notification",
        message: error?.response?.data?.message ?? "something went wrong",
        variant: "danger",
      });
    }

  }


  const renderActionButtons = () => {
    if (!userData || !sessionStatus || !sessionTimeStatus) return null;

    if (singleInboxItem?.conversationStatus === 'Assigned' && new Date(singleInboxItem?.endTime) < new Date()) {
      return null;
    }
    const buttons = [];

    const isClient = userData.role === "client";
    const isExternalExpert = userData.role === "external_expert";
    const isExpert = userData.role === "expert";
    console.log("createdByMe-singleInboxItem", singleInboxItem)
    const createdByMe = singleInboxItem?.createdBy?.id === auth?.user?.id;
    const { isSessionInWhile, isCurrentSession, isPastSession } = sessionTimeStatus;
    const { type: sessionType } = sessionStatus;

    const ButtonJoin = (
      <Button
        variant="primary"
        // onClick={()=>alert("Join now")}
        onClick={(event) => { joinCallButton(event) }}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image src="/images/link-white.svg" width={20} height={20} alt="Join Icon" />
        {(hasCallHistoryForUser) ? "Rejoin" : "Join Now"}
      </Button>
    );

    const ButtonChat = (
      <Button
        variant={isCurrentSession ? "gray" : "primary"}
        onClick={() => { console.log("location.state", singleInboxItem); navigate("/chat", { state: { singleInboxItem } }) }}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image src={isCurrentSession ? "/images/chat-circle-text-primary.svg" : "/images/chat-circle-text-white.svg"} width={20} height={20} alt="Chat Icon" />
        Chat
      </Button>
    );

    const ButtonChatExpired = (
      <Button
        variant="primary"
        onClick={() => chatActionHandle(singleInboxItem?.id)}
        // onClick={()=>navigate("/chat", { state: { singleInboxItem } })}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image src="/images/chat-circle-text-white.svg" width={20} height={20} alt="Chat Icon" />
        Chat
      </Button>
    );

    const ButtonReschedule = (
      <Button
        variant={isSessionInWhile || isCurrentSession || isPastSession ? "gray" : "primary"}
        onClick={() => {
          setRequestDate(formatDateForInputLocal(singleInboxItem?.startTime));
          setStartTimeReschedule(formatTimeForInputLocal(singleInboxItem?.startTime));
          setEndTimeReschedule(formatTimeForInputLocal(singleInboxItem?.endTime));
          setRescheduleModal(true);
        }}
        className="btn-md d-inline-flex align-items-center gap-2"
      >
        <Image src={isSessionInWhile || isCurrentSession || isPastSession ? "/images/calendar-dots-primary.svg" : "/images/calendar-dots-white.svg"} width={20} height={20} alt="Check Icon" />
        Reschedule
      </Button>
    );

    const ButtonCancel = (
      <Button
        variant="outline-secondary"
        onClick={() => setShowModalCancel(singleInboxItem?.id)}
        className="btn-md"
      >
        Cancel
      </Button>
    );

    if (isCurrentSession && sessionType === "confirmed") {
      return <>{ButtonJoin} {ButtonChat}</>;
    }

    if (isClient) {

      console.log("isClient " + " isSessionInWhile " + isSessionInWhile + " sessionType " + sessionType)
      if (isSessionInWhile && sessionType === "confirmed") {
        if (createdByMe) {
          return <>{ButtonChat}{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonChat}{ButtonReschedule}{ButtonCancel}</>;
        }

      } else if (!isSessionInWhile && sessionType === "confirmed") {
        if (createdByMe) {
          return <>{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonReschedule}{ButtonCancel}</>;
        }

      } else if (sessionType === "expired") {
        return <>{ButtonChat}{ButtonJoin}</>;
      } else if (isPastSession) {
        return <>{ButtonChat}{ButtonJoin}</>;
      } else {
        return <>{ButtonChat}{ButtonJoin}</>;
      }
    }
    if (sessionType === "expired" && singleInboxItem?.createdBy?.createdBy !== singleInboxItem?.admin?.id) {
      return <>{ButtonReschedule}{ButtonCancel}</>
    }
    // External Expert Rules
    if (isExternalExpert || isExpert) {
      if (isSessionInWhile && sessionType === "pending") {
        if (createdByMe) {
          return <>{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonReschedule}</>;
        }

      }
      if (!isSessionInWhile && sessionType === "pending") {
        if (createdByMe) {
          return <>{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonReschedule}</>;
        }
      }
      if (isSessionInWhile && sessionType === "confirmed") {
        if (createdByMe) {
          return <>{ButtonChat}{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonReschedule}{ButtonChat}</>;
        }

      }
      if (!isSessionInWhile && sessionType === "confirmed") {
        return <>{ButtonReschedule}{ButtonCancel}</>;
      }
      if (isCurrentSession && sessionType === "confirmed") {
        return <>{ButtonReschedule}{ButtonJoin}{ButtonChat}</>;
      }
      if (!isCurrentSession && !isSessionInWhile && sessionType === "expired") {
        if (createdByMe) {
          return <>{ButtonChatExpired}{ButtonReschedule}{ButtonCancel}</>;
        } else {
          return <>{ButtonChatExpired}{ButtonReschedule}</>;
        }

      }
    }

    // Default Fallback
    return null;
  };

  useEffect(() => {
    setFormErrors({})
    setSingleInboxItem(item);
    // setSelfCreatedRequest(item?.createdBy?.id == loggedInUser?.user?.id);
  }, [item])

  const hasCallHistoryForUser = singleInboxItem?.calls?.some(call =>
    call.callHistories?.some(history => history.user_id === auth.user.id)
  );

  function formatTime(date) {
    return date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }

  return (
    <>
      <DetailsPanel isOpen={!!item}>
        <div
          className={classNames(
            styles["detail-panel-head"],
            "d-flex align-items-center justify-content-between gap-3"
          )}
        >
          <h2 className="h5 fw-semibold mb-0">Session Information</h2>
          <button type="button" className="btn-reset" onClick={onClose}>
            <Image src="/images/btn-close-square.svg" />
          </button>
        </div>
        <div className={styles["detail-panel-body"]}>
          {singleInboxItem?.createdBy?.createdBy !== singleInboxItem?.admin?.id && singleInboxItem?.createdBy?.id == auth?.user?.id ? <div className="d-flex align-items-center gap-3">
            {singleInboxItem?.admin?.profilePic ? (
              <ImagePreviewLightbox className="user-avtar user-avtar-48" src={singleInboxItem?.admin?.profilePic}>
                <Image
                  width="48"
                  height="48"
                  alt="User Avatar"
                  className="object-fit-cover rounded-circle"
                  src={singleInboxItem?.admin?.profilePic}
                />
              </ImagePreviewLightbox>
            ) : (
              <div className="user-avtar user-avtar-48 bg-blue-600">{singleInboxItem?.admin?.companyName?.charAt(0)}</div>
            )}
            <div>
              <h3 className="fs-20 fw-semibold mb-0">{singleInboxItem?.admin?.companyName || ''}</h3>
              <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                <li
                  className={`fs-14 fw-medium ${getCompanyStatus(singleInboxItem?.admin.companyHours)
                    .status === "Closed"
                    ? "text-red-500"
                    : "text-blue-600"
                    }`}
                >
                  {
                    getCompanyStatus(singleInboxItem?.admin?.companyHours)
                      .status
                  }
                </li>
                <li className="dot-separator"></li>
                <li className="fs-14 fw-normal text-gray-500">
                  {getCompanyStatus(singleInboxItem?.admin?.companyHours).time}
                </li>
              </ul>
            </div>
          </div> : <div className="d-flex align-items-center gap-3">
            {anotherMember?.user?.profilePic ? (
              <ImagePreviewLightbox className="user-avtar user-avtar-48" src={anotherMember?.user?.profilePic}>
                <Image
                  width="48"
                  height="48"
                  alt="User Avatar"
                  className="object-fit-cover rounded-circle"
                  src={anotherMember?.user?.profilePic}
                />
              </ImagePreviewLightbox>
            ) : (
              <Image
                width="48"
                height="48"
                alt="User Avatar"
                className="object-fit-cover rounded-circle"
                src={`https://ui-avatars.com/api/?name=${anotherMember?.user?.firstName}+${anotherMember?.user?.lastName}&background=007bff&color=fff&size=100`}
              />

            )}
            <div>
              <h3 className="fs-20 fw-semibold mb-0">{anotherMember?.user?.firstName || ''} {anotherMember?.user?.lastName || ''}</h3>
              <ul className="d-flex flex-wrap align-items-center gap-1 list-unstyled mb-0">
                <li className="fs-14">{anotherMember?.user?.email || ''}</li>
                <li className="dot-separator md"></li>
                <li className="fs-14">+{anotherMember?.user?.countryCode || ''}{anotherMember?.user?.phoneNo || ''}</li>
              </ul>
            </div>
          </div>}
          {singleInboxItem?.conversationType !== "internal call" && (

            singleInboxItem?.createdBy?.createdBy !== singleInboxItem?.admin?.id && singleInboxItem?.createdBy?.id == auth?.user?.id ? (
              <div className="border-top pt-4 mt-4">
                <h4 className="text-blue fs-7 fw-medium mb-4">Company Details</h4>

                <div className="mb-3">
                  <span className="fs-14 text-gray-500 d-block mb-2">
                    Company Email
                  </span>
                  <div className="d-flex align-items-center gap-2">
                    {singleInboxItem?.admin?.email || " "}
                  </div>
                </div>
                <div className="mb-3">
                  <span className="fs-14 text-gray-500 d-block mb-2">
                    Company Phone
                  </span>
                  <div className="d-flex align-items-center gap-2">
                    +{singleInboxItem?.admin?.countryCode || " "}{singleInboxItem?.admin?.phoneNo}
                  </div>
                </div>
                <div className="mb-3">
                  <span className="fs-14 text-gray-500 d-block mb-2">
                    Company Address
                  </span>
                  <p className="mb-0">
                    {`${singleInboxItem?.admin?.address || ''}, ${singleInboxItem?.admin?.city || ''}, ${singleInboxItem?.admin?.state.name || ''}, ${singleInboxItem?.admin?.country.name || ''} ,${singleInboxItem?.admin?.zipCode || ''}`}
                  </p>
                </div>
              </div>
            ) : (
              <div className="border-top pt-4 mt-4">
                <h4 className="text-blue fs-7 fw-medium mb-4">Company Details</h4>

                <div className="mb-3">
                  <span className="fs-14 text-gray-500 d-block mb-2">
                    Company Name
                  </span>
                  <div className="d-flex align-items-center gap-2">
                    {anotherMember?.user?.companyName || ""}
                  </div>
                </div>
                <div className="mb-3">
                  <span className="fs-14 text-gray-500 d-block mb-2">
                    Company Address
                  </span>
                  <p className="mb-0">
                    {`${anotherMember?.user?.address || ''}, ${anotherMember?.user?.city || ''}, ${anotherMember?.user?.state.name || ''}, ${anotherMember?.user?.country.name || ''} ,${anotherMember?.user?.zipCode || ''}`}

                  </p>
                </div>
              </div>
            )
          )}

          <div className="border-top pt-4 mt-4">
            <h4 className="text-blue fs-7 fw-medium mb-4">Session Details</h4>

            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-2">
                Channel
              </span>
              <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                {singleInboxItem?.conversationType?.includes("chat")
                  ? <li className="session-type-badge d-flex align-items-center gap-2">
                    <Image
                      src="/images/chats-circle.svg"
                      width={20}
                      height={20}
                      alt="Chat Circle Icon"
                    />{" "}
                    Chat
                  </li>
                  : <li className="session-type-badge d-flex align-items-center gap-2">
                    <Image
                      src="/images/video-camera-blue.svg"
                      width={20}
                      height={20}
                      alt="Video Camera Blue Icon"
                    />{" "}
                    Video
                  </li>}
              </ul>
            </div>
            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-2">
                {singleInboxItem?.conversationType?.includes("chat") ? "Session Time" : "Session Timeline"}
              </span>
              <p className="mb-0">{formatDateTimeToString(singleInboxItem?.startTime || singleInboxItem?.createdAt)}{singleInboxItem?.endTime && (" - " + formatDateTimeToString(singleInboxItem?.endTime))}</p>
            </div>
            {singleInboxItem?.startTime && singleInboxItem?.endTime && (
              <div className="mb-3">
                <span className="fs-14 text-gray-500 d-block mb-2">
                  Total Session Duration
                </span>
                <p className="mb-0">{getHourMinuteDiffString(new Date(singleInboxItem.endTime), new Date(singleInboxItem.startTime))}</p>
              </div>
            )}
            {/* <div className="mb-3">
            <span className="fs-14 text-gray-500 d-block mb-2">
              Video Session Total Duration
            </span>
            <p className="mb-0">30 min</p>
          </div>
          <div className="mb-3">
            <span className="fs-14 text-gray-500 d-block mb-2">
              Chat Session Total Duration
            </span>
            <p className="mb-0">30 min</p>
          </div> */}
          </div>

          {singleInboxItem?.expertise && <div className="border-top pt-4 mt-4">
            <h4 className="text-blue fs-7 fw-medium mb-4">Expert Details</h4>
            {singleInboxItem?.createdBy?.createdBy !== singleInboxItem?.admin?.id &&
              singleInboxItem?.createdBy?.id === auth?.user?.id && (
                <div className="mb-3">
                  {singleInboxItem?.conversationMembers?.length === 2 && (
                    <>
                      <span className="fs-14 text-gray-500 d-block mb-2">
                        Expert
                      </span>

                      <div className="d-flex align-items-center gap-2">
                        <Image
                          width={48}
                          height={48}
                          alt="User Avatar"
                          className="object-fit-cover rounded-circle"
                          src={anotherMember?.user?.profilePic}
                        />

                        <span className="fs-20 fw-semibold mb-0">
                          {anotherMember?.user?.firstName || ""}{" "}
                          {anotherMember?.user?.lastName || ""}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              )}
            <div className="mb-3">
              <span className="fs-14 text-gray-500 d-block mb-2">Expertise</span>
              <p className="mb-0">{singleInboxItem?.expertise?.name}</p>
            </div>
          </div>}
        </div>

        <div
          className={classNames(
            styles["detail-panel-footer"],
            "d-flex flex-wrap align-items-center gap-2"
          )}
        >

          {renderActionButtons()}
          {/* <Button
          variant="primary"
          className="btn-md d-inline-flex align-items-center gap-2"
        >
          <Image
            src="/images/chat-circle-text-white.svg"
            width={20}
            height={20}
            alt="Chat Circle Text Icon"
          />{" "}
          Chat
        </Button>
        <Button
          variant="primary"
          className="btn-md d-inline-flex align-items-center gap-2"
        >
          <Image
            src="/images/link-white.svg"
            width={20}
            height={20}
            alt="Lunk Icon"
          />{" "}
          Join Now
        </Button>
        <Button
          variant="primary"
          className="btn-md d-inline-flex align-items-center gap-2"
        >
          <Image
            src="/images/check-white.svg"
            width={20}
            height={20}
            alt="Check Icon"
          />{" "}
          Accept
        </Button>
        <Button
          variant="gray"
          className="btn-md d-inline-flex align-items-center gap-2"
        >
          <Image
            src="/images/chat-circle-text-line-primary.svg"
            width={20}
            height={20}
            alt="Calendar Dots Icon"
          />{" "}
          Chat
        </Button>
        <Button variant="outline-secondary" className="btn-md">
          Cancel
        </Button> */}
        </div>
      </DetailsPanel>
      <Modal
        className="user-detail-modal"
        size="xl"
        show={rescheduleModal}
        onHide={() => (setRescheduleModal(false), setFormErrors({}))}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body className="h-100 p-0">
          <div className="h-100 d-flex align-items-start gap-3">
            <div className="user-modal-session-details">
              <div className="border-bottom border-grey-200 p-4">
                <h2 class="fs-20 fw-semibold text-gray-700 mb-0">
                  Session Information
                </h2>
              </div>
              <div className="p-4">
                {anotherMember ?
                  <div className="d-flex align-items-center gap-3">
                    {(anotherMember?.user?.profilePic) ? (<Image
                      width="48"
                      height="48"
                      alt="User Avatar"
                      className="object-fit-cover rounded-circle"
                      src={anotherMember?.user?.profilePic}
                    />) : <div className="user-avtar user-avtar-48 bg-blue-600">{anotherMember?.user?.firstName.charAt(0)}</div>}

                    <div>
                      <h3 className="fs-20 fw-semibold mb-0">
                        {
                          (anotherMember?.user?.firstName && anotherMember?.user?.lastName) ? (
                            `${anotherMember.user.firstName} ${anotherMember.user.lastName}`
                          ) : (
                            `${singleInboxItem?.createdBy?.firstName || ''} ${singleInboxItem?.createdBy?.lastName || ''}`
                          )
                        }
                      </h3>
                      <ul className="d-flex flex-wrap align-items-center gap-1 list-unstyled mb-0">
                        <li className="fs-14">
                          {
                            anotherMember?.user?.email
                              ? anotherMember.user.email
                              : singleInboxItem?.createdBy?.email || ""
                          }
                        </li>
                        <li className="dot-separator md"></li>
                        <li className="fs-14">
                          {
                            (anotherMember?.user?.countryCode && anotherMember?.user?.phoneNo) ? (
                              `+${anotherMember.user.countryCode} ${anotherMember.user.phoneNo}`
                            ) : (
                              `+${singleInboxItem?.createdBy?.countryCode || ''} ${singleInboxItem?.createdBy?.phoneNo || ''}`
                            )
                          }

                        </li>
                      </ul>
                    </div>
                  </div> : 'profile details not found'}

                {singleInboxItem?.conversationType !== 'internal call' && <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Company Details
                  </h4>

                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Company Name
                    </span>
                    <div className="d-flex align-items-center gap-2">
                      <Image
                        width="32"
                        height="32"
                        alt="User Circle Gear Icon"
                        src="/images/user-circle-gear-blue.svg"
                      />
                      {anotherMember ? <>{anotherMember?.user?.companyName ?? singleInboxItem?.createdBy?.companyName}</> : <>{singleInboxItem?.admin?.companyName}</>}
                    </div>
                  </div>
                  {anotherMember && <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Company Address
                    </span>
                    <p className="mb-0">{getAddress(singleInboxItem)}</p>
                  </div>}
                </div>}

                <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Session Details
                  </h4>

                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Channel
                    </span>
                    <ul className="d-flex flex-wrap align-content-center gap-2 list-unstyled mb-0">
                      {singleInboxItem?.conversationType?.includes("chat") ? (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/chats-circle.svg"
                            width={20}
                            height={20}
                            alt="Chat Circle Icon"
                          />{" "}
                          Chat
                        </li>
                      ) : (
                        <li className="session-type-badge d-flex align-items-center gap-2">
                          <Image
                            src="/images/video-camera-blue.svg"
                            width={20}
                            height={20}
                            alt="Video Camera Blue Icon"
                          />{" "}
                          Video
                        </li>
                      )}
                    </ul>
                  </div>
                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Session Timeline
                    </span>
                    <p className="mb-0">
                      {formatDateTimeToString(
                        singleInboxItem?.startTime || singleInboxItem?.createdAt
                      )}
                      {singleInboxItem?.endTime &&
                        " - " +
                        formatDateTimeToString(singleInboxItem?.endTime)}
                    </p>
                  </div>

                  {singleInboxItem?.startTime && singleInboxItem?.endTime && (
                    <div className="mb-3">
                      <span className="fs-14 text-gray-500 d-block mb-2">
                        Total Session Duration
                      </span>
                      <p className="mb-0">
                        {getHourMinuteDiffString(
                          new Date(singleInboxItem.endTime),
                          new Date(singleInboxItem.startTime)
                        )}
                      </p>
                    </div>
                  )}
                </div>

                {singleInboxItem?.expertise && <div className="border-top pt-4 mt-4">
                  <h4 className="text-blue-800 fs-7 fw-medium mb-4">
                    Expert Details
                  </h4>
                  <div className="mb-3">
                    <span className="fs-14 text-gray-500 d-block mb-2">
                      Expertise
                    </span>
                    <p className="mb-0">{singleInboxItem?.expertise?.name}</p>
                  </div>
                </div>}
              </div>
            </div>

            <div className="user-modal-session-info d-flex flex-column">
              <div className="border-bottom border-grey-200 p-4">
                <h2 class="fs-20 fw-semibold text-gray-700 mb-0">Reschedule</h2>
              </div>
              <div className="flex-grow-1 p-3">
                <Form.Group controlId="request-date" className="position-relative mb-3">
                  <Form.Label>Request Date</Form.Label>
                  <div className="form-control-date">
                    <Form.Control
                      type="date"
                      name="request-date"
                      value={requestDate}
                      onChange={(e) => setRequestDate(e.target.value)}
                      min={new Date().toISOString().split('T')[0]}
                      className={`${formErrors.requestDate ? "is-invalid" : ""}`}
                    />
                    {formErrors.requestDate && <div className="invalid-feedback">{formErrors.requestDate}</div>}
                  </div>
                </Form.Group>

                {/* START TIME */}
                <Form.Group controlId="start-time" className="position-relative mb-3">
                  <Form.Label>Start Time</Form.Label>
                  <Form.Select
                    name="start-time"
                    value={startTimeReschedule}
                    onChange={(e) => setStartTimeReschedule(e.target.value)}
                    className={`form-control-time ${formErrors.startTimeReschedule ? "is-invalid" : ""}`}
                  >

                    {timeOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  {formErrors.startTimeReschedule && <div className="invalid-feedback">{formErrors.startTimeReschedule}</div>}

                </Form.Group>

                {/* END TIME */}
                <Form.Group controlId="end-time" className="position-relative mb-3">
                  <Form.Label>End Time</Form.Label>
                  <Form.Select
                    name="end-time"
                    value={endTimeReschedule}
                    onChange={(e) => setEndTimeReschedule(e.target.value)}
                    className={`form-control-time ${formErrors.endTimeReschedule ? "is-invalid" : ""}`}
                  >
                    {timeOptions.map(({ value, label }) => (
                      <option key={value} value={value}>
                        {label}
                      </option>
                    ))}
                  </Form.Select>
                  {formErrors.endTimeReschedule && <div className="invalid-feedback">{formErrors.endTimeReschedule}</div>}

                </Form.Group>
              </div>
              <div className="d-flex align-items-center gap-2 border-top p-3">
                <Button variant="primary" className="btn-md" onClick={() => rescheduleCall()}>
                  Update & Save
                </Button>
                <Button
                  variant="outline-secondary"
                  className="btn-md"
                  onClick={() => (setRescheduleModal(false), setFormErrors({}))}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal >
      {/* Cancel Pending Request Offcanvas */}
      < Modal
        className="info-modal"
        show={showModalCancel}
        onHide={() => setShowModalCancel(null)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Body>
          <div className="text-center">
            <Image src="/images/x-badge-red.svg" alt="X Badge" />
            <h2 className="fs-30 fw-semibold text-gray-700 mt-5 mb-2">
              Are you sure you want to cancel this chat request?
            </h2>

            <div className="d-flex align-items-center gap-3">
              <Button onClick={() => cancelRequest(showModalCancel)} variant="primary" className="btn w-100 mt-5">
                Yes, Cancel It
              </Button>
              <Button
                variant="gray"
                className="btn w-100 mt-5"
                onClick={() => setShowModalCancel(null)}
              >
                No, Not Yet!
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};

export default CalendarDetailsPanel;
